import styled from 'styled-components';

import source from '@pkg/assets/images/dashboard-nft-not-visualized-bg.png';

export const SheetBackground = styled.div`
    background-image: url(${source});
    background-repeat: no-repeat;
    background-origin: border-box;
    background-size: cover;
    background-attachment: fixed;
    width: 100%;
    height: 100%;
    position: absolute;
`;
export const SheetContent = styled.div`
    position: relative;
    height: 100%;
    padding: 30px 40px 60px;
`;
